import React, { memo, useMemo } from 'react';
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import {
  sharedStyles,
  sharedBoxShadow,
  sharedFontStyle,
} from '../sharedStyles';

interface SharedCssProps {
  sharedStyles: SerializedStyles;
  gradientStart: string;
}

interface DivCssProps extends SharedCssProps {
  sharedBoxShadow: SerializedStyles;
  gradientEnd: string;
}

interface SpanCssProps extends SharedCssProps {
  sharedFontStyle: SerializedStyles;
}

interface BorderedSecondaryButtonProps {
  gradientStart: string;
  gradientEnd: string;
}

const Div = styled.div`
  ${({
    sharedStyles,
    sharedBoxShadow,
    gradientStart,
    gradientEnd,
  }: DivCssProps) => css`
    ${sharedStyles};
    ${sharedBoxShadow};
    width: 156px;
    background-image: linear-gradient(254deg, ${gradientStart}, ${gradientEnd});
  `}
`;

const Span = styled.span`
  ${({ sharedStyles, gradientStart, sharedFontStyle }: SpanCssProps) => css`
    ${sharedStyles};
    ${sharedFontStyle}
    color: ${gradientStart};
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    background-color: #ffffff;
    border-radius: 1.5px;
  `}
`;

const BorderedSecondaryBtn: React.FC<BorderedSecondaryButtonProps> = ({
  gradientStart,
  gradientEnd,
}) => {
  const divCssProps = useMemo(
    () => ({
      sharedStyles,
      sharedBoxShadow,
      gradientStart,
      gradientEnd,
    }),
    [gradientEnd, gradientStart]
  );

  const spanCssProps = useMemo(
    () => ({
      sharedStyles,
      sharedFontStyle,
      gradientStart,
    }),
    [gradientStart]
  );

  return (
    <Div {...divCssProps}>
      <Span {...spanCssProps}>重新整理</Span>
    </Div>
  );
};

export default memo(BorderedSecondaryBtn);
